"use strict";

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject"); //tslint:disable:max-classes-per-file


var SimulatedColumn =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SimulatedColumn, _DomainObject_1$Domai);

  function SimulatedColumn(value, simulated) {
    var _this;

    var accepted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var note = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, SimulatedColumn);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimulatedColumn).call(this));
    _this.value = value;
    _this.simulated = simulated;
    _this.accepted = accepted;
    _this.note = note;
    return _this;
  }

  return SimulatedColumn;
}(DomainObject_1.DomainObject);

exports.SimulatedColumn = SimulatedColumn;

var SimulatedColumnString =
/*#__PURE__*/
function (_SimulatedColumn) {
  _inherits(SimulatedColumnString, _SimulatedColumn);

  function SimulatedColumnString() {
    _classCallCheck(this, SimulatedColumnString);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatedColumnString).apply(this, arguments));
  }

  _createClass(SimulatedColumnString, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SimulatedColumnString(mat.value, mat.simulated, mat.accepted, mat.note);
    }
  }]);

  return SimulatedColumnString;
}(SimulatedColumn);

exports.SimulatedColumnString = SimulatedColumnString;

SimulatedColumnString.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimulatedColumnString.name);
  return {
    value: builder.str('value'),
    simulated: builder.bool('simulated'),
    accepted: builder.opt(builder.bool('accepted')),
    note: builder.opt(builder.str('note'))
  };
}();

SimulatedColumnString.dataOrder = [SimulatedColumnString.schema.value.simpleNameKey(), SimulatedColumnString.schema.accepted.simpleNameKey(), SimulatedColumnString.schema.note.simpleNameKey()];

var SimulatedColumnBigNum =
/*#__PURE__*/
function (_SimulatedColumn2) {
  _inherits(SimulatedColumnBigNum, _SimulatedColumn2);

  function SimulatedColumnBigNum() {
    _classCallCheck(this, SimulatedColumnBigNum);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatedColumnBigNum).apply(this, arguments));
  }

  _createClass(SimulatedColumnBigNum, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SimulatedColumnBigNum(mat.value, mat.simulated, mat.accepted, mat.note);
    }
  }]);

  return SimulatedColumnBigNum;
}(SimulatedColumn);

exports.SimulatedColumnBigNum = SimulatedColumnBigNum;

SimulatedColumnBigNum.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimulatedColumnBigNum.name);
  return {
    value: builder.bigNum('value'),
    simulated: builder.bool('simulated'),
    accepted: builder.opt(builder.bool('accepted')),
    note: builder.opt(builder.str('note'))
  };
}();

SimulatedColumnBigNum.dataOrder = [SimulatedColumnBigNum.schema.value.simpleNameKey(), SimulatedColumnBigNum.schema.accepted.simpleNameKey(), SimulatedColumnBigNum.schema.note.simpleNameKey()];